import { useEffect } from 'react';
import ScrollReveal from 'scrollreveal';

export default function useScrollReveal(containerRef) {
  useEffect(() => {
    const container = containerRef?.current;
    if (!container) return;
    const sr = ScrollReveal();
    container.querySelectorAll('[data-sr]').forEach(el => {
      const delay = parseFloat(el.dataset.sr || '0') * 1000;
      const y = el.dataset.srY || '24';
      const scale = parseFloat(el.dataset.srScale || '1');
      sr.reveal(el, {
        origin: 'bottom',
        distance: `${y}px`,
        duration: 850,
        delay,
        scale,
        easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
        reset: false,
      });
    });
  }, [containerRef]);
}
